// src/contexts/DialogContext.tsx
'use client';

import {trackEvent} from "@/lib/analyticsUtil";
import React, {createContext, useContext, useState, ReactNode} from 'react';

interface DialogContextType {
    activeDialog: string | null;
    setActiveDialog: (dialog: string | null) => void;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export function DialogProvider({children}: { children: ReactNode }) {
    const [activeDialog, setActiveDialogState] = useState<string | null>(null);

    const setActiveDialog = (dialog: string | null) => {
        if (dialog) {
            trackEvent(
                'dialog_opened', {
                    dialog_id: dialog
                },
            );
        } else if (activeDialog) {
            trackEvent(
                'dialog_closed', {
                    dialog_id: activeDialog
                },
            );
        }
        setActiveDialogState(dialog);
    };

    return (
        <DialogContext.Provider value={{activeDialog, setActiveDialog}}>
            {children}
        </DialogContext.Provider>
    );
}

export function useDialog() {
    const context = useContext(DialogContext);
    if (!context) {
        throw new Error('useDialog must be used within a DialogProvider');
    }
    return context;
}
